import React from 'react';
import TeamMembersSection from '../../../sections/AdminDashboard/Settings/TeamMembers';

const TeamMembers = () => {
  return <TeamMembersSection />;
};

export default TeamMembers;
